module.exports = __webpack_public_path__ + "img/SES_4101005194.de525a08.jpg";